<template>
  <autocomplete ref="input" :placeholder="placeholder" :parse="parse" :search="search" v-model="model" :min-characters="3" :is-loading="loading" caret />
</template>

<script>
import Autocomplete from "@/components/layout/components/Autocomplete"
import {list} from "@/domain/pessoa/services"
const search = function (terms, tipo = null) {
  let filtros = encodeURI(`&sortBy=name&descending=false&search=${terms}`)
  if (tipo) {
    filtros = filtros + '&tag=' + (tipo === 2 ? 'fornecedor' : '')
  }
  return list(50, 1, filtros)
}
export default {
  name: "FinPessoaInput",
  components: {Autocomplete},
  props: {
    value: {
      required: true
    },
    placeholder: {
      required: false
    },
    tipo: {
      required: false
    }
  },
  data () {
    return {
      model: this.value,
      loading: false
    }
  },
  watch: {
    model(v) {
      this.$emit('input', this.model)
    },
    value(v) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.model !== v) {
            this.model = v
            this.$refs.input.set(v)
          }
        }, 100)
      })
    }
  },
  methods: {
    parse (v) {
      return v && v.name
    },
    search(terms, done) {
      this.loading = true
      search(terms, this.tipo)
          .then(response => {
            this.loading = false
           let  extra = null
            if (terms) {
              extra = {
                label: `Adicionar novo cliente`,
                value: terms,
                isNew: true,
                link: true,
                click: () => {
                  window.open('/#/pessoas#cadastro', '_blank')
                }
              }
            }
            let result = response.data.result.map(p => {
              return {
                ...p,
                label: p.name,
                value: p.name,
                active: null
              }
            })
            extra && result.push(extra)
            done(result)
          }).catch(error => {
        this.loading = false
        this.alertApiError(error)
      })
    },
  }
}
</script>
